import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { PinComponent } from '../../../common/pin/pin.component';
import {
  OnlyIntroInitModel,
  OnlyIntroInitVariables,
  OnlyIntroModel,
  OnlyIntroVariables,
} from '../../../../../models/email-template/only-intro.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { Helper } from '../../../../../utils/helper';
@Component({
    selector: 'app-only-intro',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './only-intro.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './only-intro.component.scss'
})
export class OnlyIntroComponent extends BaseComponent implements OnInit {
  @Input() block: OnlyIntroModel = new OnlyIntroInitModel();
  @Input() isPreview = false;
  count: number = 0;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new OnlyIntroInitVariables()
    }
  }

  //placeholders:
  onlyIntroPlaceholder: string = 'Enter Intro Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof OnlyIntroVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
